import {
  montserratLight,
  montserratRegular,
  montserratMedium,
  montserratSemiBold,
  montserratBold,
} from "../fonts/montserrat/montserratBase64";

// Familias tal cual quedan registradas dentro de jsPDF. Montserrat maneja
// normal/bold y las otras dos familias cubren los pesos intermedios que usa
// el diseño original de la orden de pago (Medium y SemiBold).
export const MONTSERRAT = "Montserrat";
export const MONTSERRAT_LIGHT = "MontserratLight";
export const MONTSERRAT_MEDIUM = "MontserratMedium";
export const MONTSERRAT_SEMIBOLD = "MontserratSemibold";

const FUENTES = [
  ["Montserrat-Regular.ttf", montserratRegular, MONTSERRAT, "normal"],
  ["Montserrat-Light.ttf", montserratLight, MONTSERRAT_LIGHT, "normal"],
  ["Montserrat-Bold.ttf", montserratBold, MONTSERRAT, "bold"],
  ["Montserrat-Medium.ttf", montserratMedium, MONTSERRAT_MEDIUM, "normal"],
  ["Montserrat-SemiBold.ttf", montserratSemiBold, MONTSERRAT_SEMIBOLD, "normal"],
];

export const registrarMontserrat = (doc) => {
  FUENTES.forEach(([archivo, base64, familia, estilo]) => {
    doc.addFileToVFS(archivo, base64);
    doc.addFont(archivo, familia, estilo);
  });
};
